import { create } from 'zustand';
import { getAllIntegrations, getTemplateIntegrations, getTypeIntegrations } from '../api/api';

export const useIntegrationsStore = create((set) => ({
  integrations: [],
  integrationsType: null,
  templates: [],

  setIntegrations: (integrations) =>
    set(() => ({
      integrations,
    })),

  fetchIntegrations: async () => {
    try {
      await getAllIntegrations((data) => set({ integrations: data ?? [] }));
    } catch (error) {}
  },

  fetchTypeIntegrations: async () => {
    const res = await getTypeIntegrations();
    set({ integrationsType: res?.values });
  },

  fetchTemplatesIntegrations: async () => {
    const res = await getTemplateIntegrations();
    set({ templates: res });
  },
}));
